import {
  BaseUniDriver,
  UniDriver,
} from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export interface FileUploadUniDriver extends BaseUniDriver {}

export const fileUploadDriverFactory = (
  base: UniDriver,
): FileUploadUniDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
